import http, { url, getBase } from '../../http'

const API_URL = "gsystem_occupational_hazards"

class afiliacionSistemaRiesgosAPI {

  async validatePayroll(file, companies_id, contract_type) {
    const form = new FormData()
    form.append('file', file)
    form.append('companies_id', companies_id)
    if (contract_type !== null && contract_type !== undefined) {
      form.append('contract_type', contract_type)
    }

    const response = await fetch(`${getBase()}${API_URL}/validate-payroll`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: form,
    })
    return response.json()
  }

  async save(gsystem_occupational_hazards) {
    const response = await http(`${API_URL}/save`, 'POST', gsystem_occupational_hazards)
    return response
  }

  async saveMulti(gsystem_occupational_hazards) {
    const response = await http(`${API_URL}/multyStore/save`, 'POST', gsystem_occupational_hazards)
    return response
  }

  async saveEvaluacion(calification_evaluation_providers) {
    const response = await http(`calification_evaluation_providers/save`, 'POST', calification_evaluation_providers)
    return response
  }
 
  async getAll(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  } 

  async getAllS(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getContratistas(id) {
    const response = await http(`gsystem_occupational_hazards/list/${id}`)
    return response
  } 

  
  async getEmpleados(id) {
    const response = await http(`gsystem_occupational_hazards/listEmployees/${id}`)
    return response
  } 

  async getAllSeleccion(idEvaluacion) {
    const response = await http(`calification_evaluation_providers/${idEvaluacion}`)
    return response
  } 

  async getAllEvaluacionSeleccion(idEvaluacion, page, search) {
    const response = await http(`calification_evaluation_providers/${idEvaluacion}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getAllEvaluacion(page, search) {
    const response = await http(`${API_URL}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getShow(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  } 

  async getFiles(id) {
    const response = await http(`identification_evaluation_files/${id}`, 'POST')
    return response
  } 



  async update(id, revision) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revision)
    return response
  }
  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  
}

export default new afiliacionSistemaRiesgosAPI()